import { render, staticRenderFns } from "./mp4Player.vue?vue&type=template&id=cfedad52&scoped=true"
import script from "./mp4Player.vue?vue&type=script&lang=js"
export * from "./mp4Player.vue?vue&type=script&lang=js"
import style0 from "./mp4Player.vue?vue&type=style&index=0&id=cfedad52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfedad52",
  null
  
)

export default component.exports